import { getUserInfo, logOut, PWARewardAPI } from "@/api/user";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useGameStore } from "./games";

export const useUserStore = defineStore("user", () => {
  const balance = ref(0);
  const nickname = ref("");
  const id = ref(0);
  const loginAccount = ref("")
  const headimg = ref("")
  const unreadCount = ref(0)
  const unreadMsgIdList = ref<{ id: number; [key: string]: any }[]>([])
  const unreadActivityMsgList = ref([])
  const totalMsgListCount = ref(0)
  const gameStore = useGameStore()
  const acceptFirstRechargeBonus = ref(0)
  const isFirstRechargeRewardEligible = ref(false)
  const VIPData = ref({
    cumulativeBetTotal : 0,
    currentLevel: 0,
    nextLevel : 0,
    bet_min : 0
    })

  const resetUserData = () => {
      balance.value = 0;
      nickname.value = "";
      id.value = 0;
      loginAccount.value = "";
      headimg.value = "";
      unreadCount.value = 0;
      unreadMsgIdList.value = [];
      unreadActivityMsgList.value = [];
      totalMsgListCount.value = 0;
      acceptFirstRechargeBonus.value = 0
      isFirstRechargeRewardEligible.value = false
      VIPData.value = {
         cumulativeBetTotal : 0,
          currentLevel: 0,
          nextLevel : 0,
          bet_min : 0
        }
      localStorage.setItem("token", '');
      gameStore.resetGroupList()
      localStorage.setItem('footerPopupOpen', String(0))
  }

  const signOut = async (): Promise<void> => {
    try {
    const res = await logOut();
    if (res) {
      resetUserData()
      location.reload()
      sessionStorage.setItem('openPromotionPopup', '');
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  } catch (error) {
    console.error("logout failed:", error);
  }
    

  }

  const getInfo = async (): Promise<void> => {
  try {
    const res = await getUserInfo();
    if (res) {
      const data = res.data;
      nickname.value = data.user.nickname || "";
      id.value = data.user.id || 0;
      balance.value = data.user_account.coin || 0;
      loginAccount.value = data.user.loginAccount || "";
      headimg.value = data.user.headimg || "";
      acceptFirstRechargeBonus.value = data.user.acceptFirstRechargeBonus || 0
      VIPData.value = {
         cumulativeBetTotal : data?.user_daily.cumulativeBetTotal || 0,
          currentLevel: data?.user_account.vip || 0,
          nextLevel : data?.user_next_vip.level || 0,
          bet_min : data?.user_next_vip.bet_min || 0

        }
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  } catch (error) {
    console.error("getUserInfo failed:", error);
  }
};

const getPWARewardAPI = async () => {
  try {
    const res = await PWARewardAPI();
    if (res) {
      getInfo();
    }
  } catch (error) {
    console.error("getPWAReward failed:", error);
  }
}

const setRemainUnreadMsgList = (list : any) => {
  unreadMsgIdList.value = list
  unreadCount.value = unreadMsgIdList.value.length
}

const setMsgList = (list : any) => {
   const mergedList = [...unreadMsgIdList.value, ...list];
  unreadMsgIdList.value = Array.from(new Set(mergedList));
   unreadCount.value = unreadMsgIdList.value.length
}

const setActivityMsgList = (list : any ) => {
  unreadActivityMsgList.value = Array.from(new Set(list));
  const allMsgs = list.flatMap((item : any) => item.msgList);
  totalMsgListCount.value = allMsgs.length
}

const reSetUnreadMessages = () => {
  unreadCount.value = 0
  unreadMsgIdList.value = []
}

const setFirstRechargePopupShowStatus = (data : any) => {
  acceptFirstRechargeBonus.value = data
}

const setisFirstRechargeRewardEligible = (data : any) => {
  isFirstRechargeRewardEligible.value = data
}
  return {
    balance,
    nickname,
    id,
    loginAccount,
    headimg,
    unreadCount,
    unreadMsgIdList,
    unreadActivityMsgList,
    totalMsgListCount,
    acceptFirstRechargeBonus,
    isFirstRechargeRewardEligible,
    VIPData,
    getInfo,
    signOut,
    getPWARewardAPI,
    setRemainUnreadMsgList,
    setMsgList,
    reSetUnreadMessages,
    resetUserData,
    setActivityMsgList,
    setFirstRechargePopupShowStatus,
    setisFirstRechargeRewardEligible
  };
}, {
  persist: true,
});
